import api from "./api";

export type PageMeta = {
  slug: string;
  title?: string;
  description?: string;
};

export async function fetchPageMeta(slug: string): Promise<PageMeta | null> {
  const { data } = await api.get<PageMeta[]>("/api/v1/page-meta/");

  if (Array.isArray(data)) {
    return data.find((item) => item.slug === slug) || null;
  }
  return null;
}
